import Loadable from 'react-loadable'

import MainLayout from '../../components/admin/layout/MainLayout'
import LoadingPage from '../../components/admin/layout/Loading'

const systemPage = Loadable({
  loader: () => import('../../pages/admin/Dashdoard/Index'),
  loading: LoadingPage,
})

const systemRoutes = [
  {
    path: '/admin',
    exact: true,
    requiredAuth: true,
    component: systemPage,
    layout: MainLayout,
  },
  {
    path: '/admin/dashdoard',
    exact: true,
    requiredAuth: true,
    component: systemPage,
    layout: MainLayout,
  },
]

export default systemRoutes
